import { render, staticRenderFns } from "./NoAccessPrivatePage.vue?vue&type=template&id=6fcc57b0&"
import script from "./NoAccessPrivatePage.vue?vue&type=script&lang=js&"
export * from "./NoAccessPrivatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports